import React from 'react';
import styled from 'styled-components';
import { Heading4 } from 'Common/UI/Text/Headings';
import Paragraph, { SmallParagraph } from 'Common/UI/Text/Paragraph';
import Button from './Button';

const ReopenedIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: ${({ theme }) => theme.colours.lightOrange};
  border-radius: 4px;
  margin-bottom: ${({ theme }) => theme.spacing[10]};
`;

const ReopenedContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const ReopenedHeading = styled(Heading4)`
  margin: 0;
  margin-bottom: 10px;
`;

const ReopenedDescription = styled(Paragraph)`
  margin: 0;
`;

const ReopenedFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
`;

const ReopenedRequired = styled(SmallParagraph)`
  margin: 0px;
  font-weight: 700;
`;

type ReopenedIndicatorProps = {
  heading: string;
  description: string;
  target: () => void;
};

const ReopenedIndicator: React.FC<ReopenedIndicatorProps> = ({
  heading,
  description,
  target,
}) => (
  <ReopenedIndicatorWrapper>
    <ReopenedContent>
      <ReopenedHeading>{heading}</ReopenedHeading>
      <ReopenedDescription>{description}</ReopenedDescription>
      <ReopenedFooter>
        <Button onClick={target}>Answer now</Button>
        <ReopenedRequired>Required</ReopenedRequired>
      </ReopenedFooter>
    </ReopenedContent>
  </ReopenedIndicatorWrapper>
);

export default ReopenedIndicator;
